function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9 0 C 13.96875 0 18 4.03125 18 9 C 18 13.96875 13.96875 18 9 18 C 4.03125 18 0 13.96875 0 9 C 0 4.03125 4.03125 0 9 0 Z M 9 16.902344 C 13.339844 16.902344 16.882812 13.339844 16.882812 9 C 16.882812 4.660156 13.339844 1.117188 9 1.117188 C 4.660156 1.117188 1.132812 4.660156 1.132812 9 C 1.132812 13.339844 4.660156 16.902344 9 16.902344 Z M 8.386719 9.558594 L 5.058594 9.558594 C 4.910156 9.558594 4.765625 9.503906 4.660156 9.398438 C 4.554688 9.292969 4.496094 9.148438 4.5 9 C 4.5 8.675781 4.753906 8.441406 5.058594 8.441406 L 12.941406 8.441406 C 13.246094 8.441406 13.5 8.675781 13.5 9 C 13.503906 9.148438 13.445312 9.292969 13.339844 9.398438 C 13.234375 9.503906 13.089844 9.558594 12.941406 9.558594 Z M 8.386719 9.558594 "
}));

var SvgMinusButton = function SvgMinusButton(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18pt",
    height: "18pt",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinusButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minus-button.88a94eac.svg";
export { ForwardRef as ReactComponent };